export function trackEvent(name, payload = {}) {
  try {
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track(name, payload);
      return;
    }
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    // Fallback: console log so events are visible during development
    // Consumers can replace or extend this helper to integrate with Amplitude/Segment/etc.
    // Keep payload small and serializable.
    // eslint-disable-next-line no-console
    console.log('[analytics]', name, payload);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('analytics.trackEvent error', e);
  }
}
